import dayjs from 'dayjs';
import { isUnrouteable } from '../dashboard';

export const DATE_FORMAT = 'MM/DD/YYYY';

const _addWarningFlags = (element, flags) => {
  const now = dayjs();
  if (element.appointmentDate) {
    const apptmtDate = dayjs(element.appointmentDate, DATE_FORMAT);
    const diff = now.diff(apptmtDate, 'days');
    if (diff > 0) {
      flags.push('W-A');
    }
    const dischargeDate = dayjs(element.dischargeDate, DATE_FORMAT);
    if (Math.abs(apptmtDate.diff(dischargeDate, 'days')) <= 2) {
      flags.push('W-C');
    }
    if (dischargeDate.isAfter(apptmtDate)) {
      flags.push('W-I');
    }
  }
  return flags;
};

const _addFlags = (element, organization) => {
  const flags = [];
  if (element.indicators.isPeerRequested) {
    flags.push('P');
  }
  if (element.indicators.isTelehealth) {
    flags.push('T');
  }
  if (element.isTreeOnDashboard) {
    flags.push('X');
  }
  element.flags = _addWarningFlags(element, flags);
  return element;
};

const _addUnrouteable = (element) => {
  element.isUnrouteable = isUnrouteable({
    alertStatus: element.alertStatus,
    actions: element.actionHistory.actions,
  });
  return element;
};

const _addDaysLapsed = (element) => {
  const now = dayjs();
  const dischargeDate = dayjs(element.dischargeDate, DATE_FORMAT);
  const daysLapsed = now.diff(dischargeDate, 'days');
  element.daysLapsed = daysLapsed;
  return element;
};

export const createHistoryAction = (action, user, from, to, reason) => {
  const { fullName, email, phoneNumber, organization } = user;
  const newEntry = {
    timestamp: dayjs().format(DATE_FORMAT),
    action: action,
    user: {
      name: fullName,
      email,
      phoneNumber,
      organization,
    },
    altered: {
      from,
      to,
      reason,
    },
  };
  return newEntry;
};

export const addCalculatedColumns = (data, organization = null) => {
  const withCCs = { ...data };
  _addFlags(withCCs, organization);
  _addDaysLapsed(withCCs);
  _addUnrouteable(withCCs);
  return withCCs;
};

export const formulateUserObject = (stateUser) => {
  return {
    fullName: stateUser.name.first.concat(` ${stateUser.name.last}`),
    email: stateUser.email,
    phoneNumber: stateUser.phoneNumber,
    organization: stateUser.organization,
  };
};
